import React from "react";
import { Tooltip } from "@mui/material";
import { List, User } from "react-feather";
import styled from "styled-components";
import useLocationTeamMembers from "../../../swr/hooks/Locations/useLocationTeamMembers";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  padding: 6px;
  border-radius: 8px;

  &:hover {
    cursor: pointer;
    background-color: #eeeeee;
  }
`;

const InnerContainer = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 4px;
  height: 100%;
  min-height: 60px;
  display: flex;
  padding: 4px;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 180px;
  span {
    color: black;
  }
`;

const Inner = ({ id, name }) => {
  const { teamMembers, isLoading, isError } = useLocationTeamMembers(id);

  if (isLoading) {
    return (
      <InnerContainer>
        <div
          style={{
            width: "100%",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span style={{ color: "darkgrey" }}>loading...</span>
        </div>
      </InnerContainer>
    );
  }

  if (isError) {
    return (
      <InnerContainer>
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 40,
          }}
        >
          <span style={{ color: "firebrick" }}>error loading...</span>
        </div>
      </InnerContainer>
    );
  }

  return (
    <InnerContainer>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 4,
          marginBottom: 4,
        }}
      >
        <span style={{ fontSize: 11, fontWeight: "500" }}>{name}</span>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          flexDirection: "column",
        }}
      >
        {teamMembers?.map(({ firstName, lastName }) => (
          <div
            key={firstName}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 4,
            }}
          >
            <User height={10} width={10} color="darkgrey" />
            <span style={{ fontSize: 11, fontWeight: "400" }}>
              {firstName} {lastName}
            </span>
          </div>
        ))}
      </div>
    </InnerContainer>
  );
};

const MembersInLocationTooltip = ({ id, name }) => {
  return (
    <Tooltip
      title={<Inner id={id} name={name} />}
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: "white",
            border: "1px solid slategrey",
            maxHeight: "none",
            padding: "0px",
          },
        },
      }}
    >
      <Container>
        <List height={14} width={14} color="darkgrey" />
      </Container>
    </Tooltip>
  );
};

export default MembersInLocationTooltip;
